import { styled } from "@mui/material/styles";
import { Paper } from "@mui/material";

export const StyledHeaderBox = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  mb: 2,
} as const;

export const StyledTableContainer = styled(Paper)(() => ({
  borderRadius: 8,
  boxShadow: "0 12px 30px rgba(0,0,0,0.08)",
}));

export const StyledDialogTitle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
} as const;

export const StyledDialogPaper = {
  borderRadius: 2,
} as const;

export const StyledDialogContent = {
  dividers: true,
} as const;

export const StyledDialogActions = {
  px: 3,
  py: 2,
} as const;

export const StyledFormStack = {
  spacing: 2,
} as const;
